module.exports = __webpack_public_path__ + "static/media/Intimni_myci_gel_CBD_retina.448d45cc.jpg";